import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiServices } from "../4.Utils/apiServices";

const namespace = "leave/withdrawals";

//Search HR Review by Employee's Name + Pagination
export const searchLeaveWithdrawalPagination = createAsyncThunk(
  `${namespace}/search`,
  async ({ body, currentPage }, { rejectWithValue }) => {
      const api = "search_leave_withdrawal_name+pagination";
      const replace = { 
          search: "{page}", 
          replace: currentPage 
      };
      const opt = {
          replace: replace,
          body: body
      };
      try {
      const response = await apiServices(api, opt);
      return response.data;
      } catch (err) {
      return rejectWithValue(err);
      }
  }
);

//Search HR Review Page Count
export const searchLeaveWithdrawalPageCount = createAsyncThunk(
  `${namespace}/search/PageCount`,
  async (body, { rejectWithValue }) => {
    const api = "search_leave_withdrawal_name_pageCount";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

//List of Leave Withdrawals
export const getListsOfLeaveWithdrawal = createAsyncThunk(
    `${namespace}/lists`,
    async (body, { rejectWithValue }) => {
        const api = "get_withdrawal_lists";
        const opt = {
            body: body,
        };
        try {
        const response = await apiServices(api, opt);
        return response.data;
        } catch (err) {
        return rejectWithValue(err);
        }
    }
);

//Lists of Withdrawal Total Count
export const getWithdrawalTotalCount = createAsyncThunk(
    `${namespace}/TotalCount`,
    async (body, { rejectWithValue }) => {
      const api = "get_withdrawal_lists_count";
      const opt = {
        body: body,
      };
  
      try {
        const response = await apiServices(api, opt);
        return response.data;
      } catch (err) {
        return rejectWithValue(err);
      }
    }
);

//Leave Withdrawals Review
export const reviewWithdrawal = createAsyncThunk(
    `${namespace}/review`,
    async (body, { rejectWithValue }) => {
      const api = "review_a_withdrawal_list";
      const replace = {
        search: "{leave_withdrawal_application_id}",
        replace: body.id,
      };
      const opt = {
        replace: replace,
        body: body,
      };
  
      try {
        const response = await apiServices(api, opt);
        return response.data;
      } catch (err) {
        return rejectWithValue(err);
      }
    }
);

//Medical Cert
export const getMedicalCert = createAsyncThunk(
    `${namespace}/medicalCert`,
    async (body, { rejectWithValue }) => {
      const api = "get_medical_certificate_attachment";
      const replace = {
        search: "{id}",
        replace: body.id,
      };
      const opt = {
        replace: replace,
        body: body,
      };
  
      try {
        const response = await apiServices(api, opt);
        return response.data;
      } catch (err) {
        return rejectWithValue(err);
      }
    }
);

const initialState = {
  search: {
    "searchText": "",
    "advancedLeave": true,
    "annualLeave": true,
    "hospitalizationLeave": true,
    "maternityLeave": true,
    "paternityLeave": true,
    "otherLeave": true,
    "sickLeave": true,
    "specialLeave": true,
    "unpaidLeave": true
  },
    list: {
        id: "",
        remark_withdrawal : "",
        status: {
            id: ""
        }
    },
    loading: false,
    error: false,
    currentPage: 1,
    currentPageCount: 0,
    totalPages: "",
    lists: [],
    cert: [],
    withdrawlist: null // Add withdrawlist property
}

const LeaveWithdrawalSlice = createSlice({
    name: namespace,
    initialState,
    reducers: {
        // update current page
        updateCurrentPage(state, action) {
            return { ...state, currentPage: action.payload };
        },

        // update entity
        updateSearch(state, action) {
          state.search = action.payload;
        },

        setTotalPages: (state, action) => {
          state.totalPages = action.payload;
        },
  
        // update entity
        updateReview(state, action) {
            state.list = action.payload;
        },

        // reset entity
        resetReview(state) {
            return {
                ...state,
                list: initialState.list,
                withdrawlist: initialState.withdrawlist // Reset withdrawlist
            };
        },

        resetCert(state) {
            return {
              ...state,
              cert: initialState.cert,
            };
        },

        getList(state, action) {
            return {
                ...state,
                withdrawlist: state.lists.find((withdrawlist) => withdrawlist.id == action.payload),
            };
        },
    },
    extraReducers: (builder) => {
        builder
        .addCase(getListsOfLeaveWithdrawal.pending, (state) => {
            state.loading = true;
            state.error = false;
        })
        .addCase(getListsOfLeaveWithdrawal.fulfilled, (state, action) => {
            state.loading = false;
            state.lists = action.payload;
            console.log(action.payload);
        })
        .addCase(getListsOfLeaveWithdrawal.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })

        //Put
        .addCase(reviewWithdrawal.pending, (state, action) => {
            state.loading = true;
        })
        .addCase(reviewWithdrawal.fulfilled, (state, action) => {
            state.loading = false;
        })
        .addCase(reviewWithdrawal.rejected, (state, action) => {
            state.error = true;
            state.loading = false;
            console.error(action.payload);
        })

        // Get Leave Application Page Count
        .addCase(getWithdrawalTotalCount.pending, (state, action) => {
        state.loading = true;
        })
        .addCase(getWithdrawalTotalCount.fulfilled, (state, action) => {
        state.loading = false;
        state.totalPages = action.payload;
        })
        .addCase(getWithdrawalTotalCount.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        })

        // Get Leave Application Page Count
        .addCase(searchLeaveWithdrawalPagination.pending, (state, action) => {
          state.loading = true;
        })
        .addCase(searchLeaveWithdrawalPagination.fulfilled, (state, action) => {
          state.loading = false;
          state.lists = action.payload;
        })
        .addCase(searchLeaveWithdrawalPagination.rejected, (state, action) => {
          state.loading = false;
          state.error = true;
        })

        // Get Leave Application Page Count
        .addCase(searchLeaveWithdrawalPageCount.pending, (state, action) => {
          state.loading = true;
        })
        .addCase(searchLeaveWithdrawalPageCount.fulfilled, (state, action) => {
          state.loading = false;
          state.totalPages = action.payload;
        })
        .addCase(searchLeaveWithdrawalPageCount.rejected, (state, action) => {
          state.loading = false;
          state.error = true;
        })

        .addCase(getMedicalCert.pending, (state) => {
            state.loading = true;
            state.error = false;
        })
        .addCase(getMedicalCert.fulfilled, (state, action) => {
            state.loading = false;
            state.cert = action.payload;
            console.log(action.payload);
        })
        .addCase(getMedicalCert.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    }
});

export const { updateReview, getList, resetReview, updateCurrentPage, resetCert, setTotalPages, updateSearch } = LeaveWithdrawalSlice.actions;

export default LeaveWithdrawalSlice.reducer;